// Usado na instancia identifica o stateCode e o statePhase do pedido
export const StateCode = {
  Ativo: "A",
  Invalidado: "I",
  Pendente: "P",
  Submetido: "C",
  Registado: "R",
};

export const StatePhase = {
  ParaPreenchimentoPeloRemetente: "PPR",
  ParaValidacaoDaRepresentacao: "PVR",
  ParaComplementoPeloRemetente: "PCR",
  DevolvidoAoRemetente: "DR",
  DevolvidoAoServico: "NPA",
  Invalidado: "I",
  ParaValidacaoDoServicoNPV: "NPV",
  ParaValidacaoDoServicoSPS: "SPS",
  ParaValidacaoDoSubscritor: "NPS",
  PendenteDeConfirmacaoDeIntencao: "PCU",
  Registado: "R",
  Submetido: "C",
  AguardaInformacaoCGA: "AIC",
  DevolvidoAoSubscritor: "DS",
  PedidoNaoAceitePeloServico: "PNS",
  ParaValidacaoDoServicoPCS: "PCS",
  EmAnalise: "EAN",
  RLIndeferida:"RLI"
};
